import { Textarea } from "@src/components/forms/Textarea";
import { HeaderText } from "@src/components/general/HeaderText";
import { SectionHeader } from "@src/components/general/SectionHeader";
import { Text } from "@src/components/general/Text";
import { Flexbox, VerticalFlexbox } from "@src/components/layout/Flexbox";
import { useEncounterId } from "@src/features/encounters/state/encounterActor";
import { navigation } from "@src/navigation";
import { usePatientLayoutContext } from "@src/routes/layouts/patient";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Agenda } from "./components/Agenda";

export interface TodayPageProps {
  isFallbackPolling?: boolean;
}

export const TodayPage = ({ isFallbackPolling }: TodayPageProps) => {
  const [notepad, setNotepad] = useState("");

  const { patientId } = usePatientLayoutContext();
  const encounterId = useEncounterId();

  if (!patientId) {
    return <Navigate to={navigation.dashboardNotFound()} />;
  }

  const patientIdNum = Number.parseInt(patientId, 10);
  const patientIdForAgenda =
    Number.isFinite(patientIdNum) && patientIdNum > 0
      ? patientIdNum
      : undefined;

  return (
    <VerticalFlexbox
      gap="md"
      className="min-h-0 flex-1 px-4 py-6 md:px-8 md:py-8"
    >
      <HeaderText tag="h2">Today</HeaderText>
      <Flexbox gap="lg" className="flex-1 flex-col lg:flex-row">
        <VerticalFlexbox gap="sm" className="min-w-0 flex-1">
          <SectionHeader>Agenda</SectionHeader>
          <Agenda
            encounterId={encounterId ?? undefined}
            patientId={patientIdForAgenda}
            isFallbackPolling={isFallbackPolling}
          />
        </VerticalFlexbox>
        <VerticalFlexbox gap="sm" className="min-w-0 flex-1">
          <SectionHeader>Notes</SectionHeader>
          <VerticalFlexbox gap="xs" className="min-h-0 flex-1">
            <Textarea
              placeholder="Jot down notes for this visit…"
              value={notepad}
              onChange={(e) => setNotepad(e.target.value)}
              fillHeight
              fillWidth
            />
            <Text sizing="xs" appearance="subdued" className="italic">
              Notes stay on this device until a visit session is started.
            </Text>
          </VerticalFlexbox>
        </VerticalFlexbox>
      </Flexbox>
    </VerticalFlexbox>
  );
};
